import certAnimalWelfare from '@/assets/icons/cert-animal-welfare.svg';
import certAntibioticFree from '@/assets/icons/cert-antibiotic-free.svg';
import certBiologico from '@/assets/icons/cert-biologico.svg';
import certDemeter from '@/assets/icons/cert-demeter.svg';
import certDoc from '@/assets/icons/cert-doc.svg';
import certDocg from '@/assets/icons/cert-docg.svg';
import certDop from '@/assets/icons/cert-dop.svg';
import certIgp from '@/assets/icons/cert-igp.svg';
import certIgt from '@/assets/icons/cert-igt.svg';
import certKosher from '@/assets/icons/cert-kosher.svg';
import certOgmFree from '@/assets/icons/cert-ogm-free.svg';
import certPresidio from '@/assets/icons/cert-presidio.svg';
import certStg from '@/assets/icons/cert-stg.svg';
import certHalal from '@/assets/icons/cert-halal.svg';
import certMsc from '@/assets/icons/cert-msc.svg';
import certFairTrade from '@/assets/icons/cert-fair-trade.svg';
import certChicken from '@/assets/icons/cert-chicken.svg';
import certCrueltyFree from '@/assets/icons/cert-cruelty-free.svg';
import certEcolabel from '@/assets/icons/cert-ecolabel.svg';

/** PIM certification codes from `c_pimCertifications` that have an icon. */
export type PimCertificationCode =
    | 'PIM_Certificazione_001'
    | 'PIM_Certificazione_002'
    | 'PIM_Certificazione_003'
    | 'PIM_Certificazione_004'
    | 'PIM_Certificazione_005'
    | 'PIM_Certificazione_006'
    | 'PIM_Certificazione_007'
    | 'PIM_Certificazione_008'
    | 'PIM_Certificazione_009'
    | 'PIM_Certificazione_010'
    | 'PIM_Certificazione_011'
    | 'PIM_Certificazione_012'
    | 'PIM_Certificazione_013'
    | 'PIM_Certificazione_014'
    | 'PIM_Certificazione_015'
    | 'PIM_Certificazione_016'
    | 'PIM_Certificazione_017'
    | 'PIM_Certificazione_018'
    | 'PIM_Certificazione_019'
    | 'PIM_Certificazione_020';

export type PimCertificationLabelKey = `pimCertifications.codes.${PimCertificationCode}`;

export type PimCertificationIconSlug =
    | 'cert-presidio'
    | 'cert-biologico'
    | 'cert-demeter'
    | 'cert-dop'
    | 'cert-doc'
    | 'cert-docg'
    | 'cert-igt'
    | 'cert-igp'
    | 'cert-antibiotic-free'
    | 'cert-animal-welfare'
    | 'cert-ogm-free'
    | 'cert-stg'
    | 'cert-kosher'
    | 'cert-halal'
    | 'cert-msc'
    | 'cert-fair-trade'
    | 'cert-chicken'
    | 'cert-cruelty-free'
    | 'cert-ecolabel';

export interface PimCertificationConfig {
    code: PimCertificationCode;
    labelKey: PimCertificationLabelKey;
    iconSlug: PimCertificationIconSlug;
    iconSrc: string;
}

const PIM_CERTIFICATION_CONFIG: Record<PimCertificationCode, PimCertificationConfig> = {
    PIM_Certificazione_001: {
        code: 'PIM_Certificazione_001',
        labelKey: 'pimCertifications.codes.PIM_Certificazione_001',
        iconSlug: 'cert-presidio',
        iconSrc: certPresidio,
    },
    PIM_Certificazione_002: {
        code: 'PIM_Certificazione_002',
        labelKey: 'pimCertifications.codes.PIM_Certificazione_002',
        iconSlug: 'cert-biologico',
        iconSrc: certBiologico,
    },
    PIM_Certificazione_003: {
        code: 'PIM_Certificazione_003',
        labelKey: 'pimCertifications.codes.PIM_Certificazione_003',
        iconSlug: 'cert-biologico',
        iconSrc: certBiologico,
    },
    PIM_Certificazione_004: {
        code: 'PIM_Certificazione_004',
        labelKey: 'pimCertifications.codes.PIM_Certificazione_004',
        iconSlug: 'cert-antibiotic-free',
        iconSrc: certAntibioticFree,
    },
    PIM_Certificazione_005: {
        code: 'PIM_Certificazione_005',
        labelKey: 'pimCertifications.codes.PIM_Certificazione_005',
        iconSlug: 'cert-animal-welfare',
        iconSrc: certAnimalWelfare,
    },
    PIM_Certificazione_006: {
        code: 'PIM_Certificazione_006',
        labelKey: 'pimCertifications.codes.PIM_Certificazione_006',
        iconSlug: 'cert-ogm-free',
        iconSrc: certOgmFree,
    },
    PIM_Certificazione_007: {
        code: 'PIM_Certificazione_007',
        labelKey: 'pimCertifications.codes.PIM_Certificazione_007',
        iconSlug: 'cert-demeter',
        iconSrc: certDemeter,
    },
    PIM_Certificazione_008: {
        code: 'PIM_Certificazione_008',
        labelKey: 'pimCertifications.codes.PIM_Certificazione_008',
        iconSlug: 'cert-dop',
        iconSrc: certDop,
    },
    PIM_Certificazione_009: {
        code: 'PIM_Certificazione_009',
        labelKey: 'pimCertifications.codes.PIM_Certificazione_009',
        iconSlug: 'cert-doc',
        iconSrc: certDoc,
    },
    PIM_Certificazione_010: {
        code: 'PIM_Certificazione_010',
        labelKey: 'pimCertifications.codes.PIM_Certificazione_010',
        iconSlug: 'cert-docg',
        iconSrc: certDocg,
    },
    PIM_Certificazione_011: {
        code: 'PIM_Certificazione_011',
        labelKey: 'pimCertifications.codes.PIM_Certificazione_011',
        iconSlug: 'cert-igt',
        iconSrc: certIgt,
    },
    PIM_Certificazione_012: {
        code: 'PIM_Certificazione_012',
        labelKey: 'pimCertifications.codes.PIM_Certificazione_012',
        iconSlug: 'cert-igp',
        iconSrc: certIgp,
    },
    PIM_Certificazione_013: {
        code: 'PIM_Certificazione_013',
        labelKey: 'pimCertifications.codes.PIM_Certificazione_013',
        iconSlug: 'cert-stg',
        iconSrc: certStg,
    },
    PIM_Certificazione_014: {
        code: 'PIM_Certificazione_014',
        labelKey: 'pimCertifications.codes.PIM_Certificazione_014',
        iconSlug: 'cert-kosher',
        iconSrc: certKosher,
    },
    PIM_Certificazione_015: {
        code: 'PIM_Certificazione_015',
        labelKey: 'pimCertifications.codes.PIM_Certificazione_015',
        iconSlug: 'cert-halal',
        iconSrc: certHalal,
    },
    PIM_Certificazione_016: {
        code: 'PIM_Certificazione_016',
        labelKey: 'pimCertifications.codes.PIM_Certificazione_016',
        iconSlug: 'cert-msc',
        iconSrc: certMsc,
    },
    PIM_Certificazione_017: {
        code: 'PIM_Certificazione_017',
        labelKey: 'pimCertifications.codes.PIM_Certificazione_017',
        iconSlug: 'cert-fair-trade',
        iconSrc: certFairTrade,
    },
    PIM_Certificazione_018: {
        code: 'PIM_Certificazione_018',
        labelKey: 'pimCertifications.codes.PIM_Certificazione_018',
        iconSlug: 'cert-chicken',
        iconSrc: certChicken,
    },
    PIM_Certificazione_019: {
        code: 'PIM_Certificazione_019',
        labelKey: 'pimCertifications.codes.PIM_Certificazione_019',
        iconSlug: 'cert-cruelty-free',
        iconSrc: certCrueltyFree,
    },
    PIM_Certificazione_020: {
        code: 'PIM_Certificazione_020',
        labelKey: 'pimCertifications.codes.PIM_Certificazione_020',
        iconSlug: 'cert-ecolabel',
        iconSrc: certEcolabel,
    },
};

export function getPimCertificationConfig(value: string): PimCertificationConfig | undefined {
    const code = value.trim();
    return Object.hasOwn(PIM_CERTIFICATION_CONFIG, code)
        ? PIM_CERTIFICATION_CONFIG[code as PimCertificationCode]
        : undefined;
}

export function resolvePimCertifications(values: readonly string[] | undefined): PimCertificationConfig[] {
    const configs = (values ?? []).flatMap((value) => getPimCertificationConfig(value) ?? []);
    return [...new Map(configs.map((config) => [config.code, config])).values()];
}
